import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { CompareDateService } from 'src/app/services/compare-date.service';
import { HttpService } from 'src/app/services/http.service';
import { ShareDataService } from 'src/app/services/share-data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { generateSlug } from 'src/app/helpers/slug-helper';
import { createDeptUrl } from 'src/app/helpers/url-helper';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
@Component({
  selector: 'app-important-updates',
  templateUrl: './important-updates.component.html',
  styleUrls: ['./important-updates.component.scss']
})
export class ImportantUpdatesComponent implements OnChanges {
  @Input() updates;
  importantUpdates:any;
  @Output() closeDrawer = new EventEmitter<any>();
  constructor(
    public httpService: HttpService,
    public router: Router,
    private shareDataService: ShareDataService,
    private dialogService: DialogService,
    private utilService: UtilsService,
    private translate: TranslateService,
    public compareDates:CompareDateService,
    private analytics: AngularFireAnalytics,
  ){
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  goToDept(doc, type){
    if(type==='department'){
      this.redirectToDept(doc, 'document');
    }else if(type === 'service') {
      this.redirectToDept(doc, 'service');
    }
  }
  redirectDept(item) {
      this.router.navigateByUrl(`/department/${generateSlug(item?.department_name)}`);
  }

    redirectToDept(item, type) {
      if(type == 'document') {
        let { department_url, department_name, department_id } = item;
        this.handleRedirectUrls(department_url, department_name, department_id);
      }else if(type == 'service') {
        let { url, service_name, service_id, service_type } = item;
        this.handleRedirectUrls(url, service_name, service_id);
      }
    }

    handleRedirectUrls(dept_url, dept_name, dept_id) {
      const isUrlV2 = dept_url.includes('UmangVersion2');
      const isUrlDeptt = dept_url.includes('deptt');
      const isUrlServiceCentral = dept_url.includes('servicepluscentral');
      if (
        !isUrlV2 &&
        !isUrlDeptt &&
        !isUrlServiceCentral &&
        !dept_url.endsWith('/')
      ) {
        dept_url += '/';
      }
  
      const webNewUrl = `${environment.deployUrl}/web_new/department`;
      const deptInfoParams = `url=${createDeptUrl(
        dept_url
      )}&dept_id=${dept_id}&dept_name=${dept_name}`;
      
      window.open(`${webNewUrl}?${deptInfoParams}`, '_self');      
    }

  private wrongURL() {
    this.dialogService.openDialog(ErrorDialogComponent, {
      message:this.translate.instant('messages.invalidUrl')
    });
  }

  navigateToDetails(data: any, index?){
    this.analytics.logEvent('important_update_event', {
      category: `${data?.title}_Imp_U_Web_Landing`,
      action: 'clicked',
      label: 'Imp_U_Web_Landing',
    });
    if(data?.type?.toLowerCase() != "view_only") {
      this.closeDrawer.emit(true)

    }
    if(data?.type?.toLowerCase() == "view_only") {
      return;
    }
    if(data.redirect_type === 'external' && data.redirect_url){
      window.open(data.redirect_url, '_blank');
    }
    else if(data.redirect_type === 'internal'){
      if(data?.sub_type === 'announcement'){
        window.open(data.redirect_url, '_blank');
      }
      else if(data?.sub_type === 'services' && data?.service?.url){
        this.goToDept({...data.service, ...data.department}, 'service');
      } else if(data?.sub_type === 'departments' && data?.department?.department_url) {
         this.goToDept(data.department, 'department');
      } else if (data?.sub_type === 'schemes' && data?.scheme?.slug) {
        this.router.navigateByUrl(`scheme/detail/${data.scheme.slug}`);
      }
    }
    else{
      if(data?.sub_type === 'announcement'){
        window.open(data.redirect_url, '_blank');
      }
      else if(data?.sub_type === 'services' && data?.service?.url){
        this.goToDept({...data.service, ...data.department}, 'service');
      } else if(data?.sub_type === 'departments' && data?.department?.department_url) {
         this.goToDept(data.department, 'department');
      } else if (data?.sub_type === 'schemes' && data?.scheme?.slug) {
        this.router.navigateByUrl(`home/scheme/detail/${data.scheme.slug}`);
      }
    }
  }

  closeNotificationDrawer() {
    this.analytics.logEvent('important_update_event', {
      category: 'Close_Imp_U_Web_Landing',
      action: 'clicked',
      label: 'Imp_U_Web_Landing',
    });
    this.closeDrawer.emit(true)

  }
}
